import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_326: DocMigration = {
  maxSchemaVersion: "0.0.326",
  description: "Clamp negative facade cornerBoardOffsetZ values to 0",
  apply(json: any): any {
    for (const id in json.facades) {
      const facade = json.facades[id];
      if (facade.cornerBoardOffsetZ < 0) {
        facade.cornerBoardOffsetZ = 0;
      }
    }

    return json;
  },
};

export default migration_0_0_326;
